<div class="form-horizontal" style="width:99%">
    <div class="row mb-3">
        <div class="col-12">
            <div class="btn-group-ticomix">
                <button type="button" (click)="save()" [disabled]="busy" class="btn btn-ticomix">
                    <span class="fa fa-save"></span> Save
                </button>
                <button type="button" (click)="openResetPasswordWindow()" class="btn btn-ticomix">
                    <span class="fa fa-key"></span> Reset Password
                </button>
            </div>
        </div>
    </div>

    <form class="mb-3">
        <h3>Profile</h3>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="UserName">User Name</label>
                    <input id="UserName" name="UserName" type="text" [(ngModel)]="user.UserName" [disabled]="true" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="Email">Email</label>
                    <input id="Email" name="Email" type="text" [(ngModel)]="user.Email" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="FirstName">First Name</label>
                    <input id="FirstName" name="FirstName" type="text" [(ngModel)]="user.FirstName"
                        class="form-control" />
                </div>
                <div class="form-group">
                    <label for="LastName">Last Name</label>
                    <input id="LastName" name="LastName" type="text" [(ngModel)]="user.LastName" class="form-control" />
                </div>
            </div>
        </div>
    </form>

    <div class="row">
        <div class="col-12">
            <div class="btn-group-ticomix">
                <button type="button" (click)="resetGridSettings()" class="btn btn-ticomix">
                    <span class="fa fa-redo"></span> Reset Grid Settings
                </button>
            </div>
        </div>
    </div>
</div>

<kendo-window #winResetPassword title="Reset Password" *ngIf="resetPassword.show" [(top)]="resetPassword.top"
    [(left)]="resetPassword.left" [draggable]="true" [width]="400" (close)="closeResetPasswordWindow()">
    <kendo-window-titlebar>
        <span class="k-window-title">{{winResetPassword.title}}</span>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <div class="form-vertical">
        <div class="row">
            <div class="col-md-12">
                Saving this window will set your password to the provided value. To create a random password,
                click on the shuffle button.
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <label for="NewPassword">New Password</label>
                <div class="input-group">
                    <input id="NewPassword" name="NewPassword" type="text" [(ngModel)]="resetPassword.newPassword"
                        class="form-control" />
                    <button type="button" (click)="shufflePassword()" class="btn btn-ticomix" title="Shuffle"><span
                            class="fa fa-random"></span></button>
                </div>
                <ul style="list-style: none; padding-left: 0; margin-top: 0.5rem;">
                    <li *ngFor="let check of getPasswordChecks(resetPassword.newPassword)">
                        <span *ngIf="check.met" class="fa fa-check" style="color: green;"></span>
                        <span *ngIf="!check.met" class="fa fa-times" style="color: red;"></span>
                        {{ check.label }}
                    </li>
                </ul>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <button type="button" (click)="closeResetPasswordWindow()" class="btn btn-ticomix">Cancel</button>
                <button type="button" (click)="saveResetPassword()" class="btn btn-ticomix"
                    [disabled]="!isPasswordValid(resetPassword.newPassword)">Save</button>
            </div>
        </div>
    </div>
</kendo-window>